import { Domain, } from '@repo/domain';
import { queryOptions } from '@tanstack/react-query';
import { resolveRepository } from '../registry/resolveRepository';
export const userKeys = {
    all: ['users'],
};
export const userOptions = {
    me: () => queryOptions({
        queryKey: [...userKeys.all, 'me'],
        queryFn: async () => {
            const repo = await resolveRepository(Domain.User);
            return (await repo.me()) ?? null;
        },
    }),
    update: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.update([request]);
        },
    }),
    requestCode: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.requestCode(request);
        },
    }),
    validateCode: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.validateCode(request);
        },
    }),
    validatePassword: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.validatePassword(request);
        },
    }),
    finalizeCode: () => ({
        mutationFn: async () => {
            const repo = await resolveRepository(Domain.User);
            return repo.finalizeCode();
        },
    }),
    consumeImpersonationToken: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.consumeImpersonationToken(request);
        },
    }),
    generateHandoffToken: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.generateHandoffToken(request);
        },
    }),
    consumeHandoffToken: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.consumeHandoffToken(request);
        },
    }),
    registerAsGuest: () => ({
        mutationFn: async () => {
            const repo = await resolveRepository(Domain.User);
            return repo.registerAsGuest();
        },
    }),
    convertTemporaryUser: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.convertTemporaryUser(request);
        },
    }),
    registerAsPartner: () => ({
        mutationFn: async () => {
            const repo = await resolveRepository(Domain.User);
            return repo.registerAsPartner();
        },
    }),
    applyReferralCode: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.applyReferralCode(request);
        },
    }),
    confirmReverification: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.confirmReverification(request);
        },
    }),
    updateLoginMethod: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.updateLoginMethod(request);
        },
    }),
    requestPasswordReset: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.requestPasswordReset(request);
        },
    }),
    resetPassword: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.User);
            return repo.resetPassword(request);
        },
    }),
};
